import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api, track } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [home, setHome] = useState(null);

  useEffect(() => {
    api.get("/content/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/content/home").then((r) => setHome(r.data)).catch(() => {});
  }, []);

  const openBooking = useCallback((label = "generic") => {
    const url = settings?.booking_url || "https://psalm30-2chiropractic.janeapp.com/";
    track("booking_click", label);
    window.open(url, "_blank", "noopener,noreferrer");
  }, [settings]);

  const refresh = useCallback(() => {
    api.get("/content/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/content/home").then((r) => setHome(r.data)).catch(() => {});
  }, []);

  const value = useMemo(
    () => ({ settings, home, openBooking, refresh }),
    [settings, home, openBooking, refresh]
  );

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
